<template>
  <div class="ele-body">
    <el-card shadow="never" header="微信专题" body-style="padding-bottom:0;" style="margin-bottom: 15px;">
      <!-- 搜索表单 -->
      <el-form :model="where" label-width="77px" class="ele-form-search"
               @keyup.enter.native="query()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="专题标题:">
              <el-input v-model="where.name" placeholder="请输入专题标题" clearable/>
            </el-form-item>
          </el-col>
          <el-col :md="9" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon">查询
              </el-button>
              <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon">添加</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-row :gutter="15">
      <el-col v-for="(item,index) in data" :key="index" :md="6" :sm="8" :xs="12">
        <el-card class="application-list-item ele-card-border" shadow="never">
          <div class="application-list-body">
            <div class="ele-cell">
              <el-avatar :size="34" :src="item.cover"/>
              <h6 class="ele-cell-content"><b>{{ item.title }}</b></h6>
            </div>
            <div class="application-body-item ele-elip">网址：{{ item.url }}</div>
            <div class="application-body-item ele-elip">最后更新时间：{{ item.time }}</div>
          </div>
          <el-divider/>
          <div class="application-list-footer">
            <div class="application-list-tool">
              <el-tooltip content="下载" placement="top">
                <i class="el-icon-download ele-text-secondary"/>
              </el-tooltip>
            </div>
            <el-divider direction="vertical" class="line-color-light"/>
            <div class="application-list-tool">
              <el-tooltip content="编辑" placement="top">
                <i class="el-icon-edit ele-text-secondary"/>
              </el-tooltip>
            </div>
            <el-divider direction="vertical" class="line-color-light"/>
            <div class="application-list-tool">
              <el-tooltip content="分享" placement="top">
                <i class="el-icon-share ele-text-secondary"/>
              </el-tooltip>
            </div>
            <el-divider direction="vertical" class="line-color-light"/>
            <div class="application-list-tool">
              <el-dropdown placement="bottom">
                <i class="el-icon-more ele-text-secondary"/>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>操作按钮1</el-dropdown-item>
                  <el-dropdown-item>操作按钮2</el-dropdown-item>
                  <el-dropdown-item>操作按钮3</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ListApplication",
  data() {
    return {
      where: {},
      showEdit: false,
      data: [{
        title: '微信专题1',
        url: 'http://www.rxthink.cn/',
        time: '1 小时前',
        cover: require('@/assets/demo.png')
      }, {
        title: '微信专题2',
        url: 'http://www.rxthink.cn/',
        time: '2 小时前',
        cover: require('@/assets/demo.png')
      }, {
        title: '微信专题3',
        url: 'http://www.rxthink.cn/',
        time: '8 小时前',
        cover: require('@/assets/demo.png')
      }, {
        title: '微信专题4',
        url: 'http://www.rxthink.cn/',
        time: '14 小时前',
        cover: require('@/assets/demo.png')
      }, {
        title: '微信专题5',
        url: 'http://www.rxthink.cn/',
        time: '10 小时前',
        cover: require('@/assets/demo.png')
      }, {
        title: '微信专题6',
        url: 'http://www.rxthink.cn/',
        time: '16 小时前',
        cover: require('@/assets/demo.png')
      }, {
        title: '微信专题7',
        url: 'http://www.rxthink.cn/',
        time: '6 小时前',
        cover: require('@/assets/demo.png')
      }, {
        title: '微信专题8',
        url: 'http://www.rxthink.cn/',
        time: '8 小时前',
        cover: require('@/assets/demo.png')
      }]
    }
  }
}
</script>

<style scoped>
.application-list-item {
  margin-bottom: 15px;
}

.application-list-item >>> .el-card__body {
  padding: 0;
}

.application-list-body {
  padding: 12px 15px 15px 15px;
}

.application-body-item {
  margin-top: 12px;
}

.application-body-item + .application-body-item {
  margin-top: 8px;
}

.application-list-footer {
  display: flex;
  padding: 8px 0;
}

.application-list-tool {
  flex: 1;
  text-align: center;
}

.application-list-tool >>> i {
  font-size: 18px;
  line-height: 36px;
  cursor: pointer;
}

.application-list-footer >>> .el-divider--vertical {
  height: 36px;
}
</style>